import {
  GENERATE_PO,
  PO_CSV_DOWNLOAD,
  PO_CSV_MAIL,
  PO_DISTRIBUTOR_LIST,
  PO_LIST,
  PO_OFFERTYPE_LIST,
  PO_STATE_LIST,
  PO_VIEW,
} from "./types";

export const poList = (data, onSuccess, onError) => {
  return {
    type: PO_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const poCsvDownload = (data, onSuccess, onError) => {
  return {
    type: PO_CSV_DOWNLOAD,
    data,
    onSuccess,
    onError,
  };
};

export const PoStateList = (onSuccess, onError) => {
  return {
    type: PO_STATE_LIST,
    onSuccess,
    onError,
  };
};
export const PoDistributorList = (data, onSuccess, onError) => {
  return {
    type: PO_DISTRIBUTOR_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const PoOfferType = (data, onSuccess, onError) => {
  return {
    type: PO_OFFERTYPE_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const generatePo = (data, onSuccess, onError) => {
  return {
    type: GENERATE_PO,
    data,
    onSuccess,
    onError,
  };
};
export const poCsvMail = (data, onSuccess, onError) => {
  return {
    type: PO_CSV_MAIL,
    data,
    onSuccess,
    onError,
  };
};

export const poView = (data, onSuccess, onError) => {
  return {
    type: PO_VIEW,
    data,
    onSuccess,
    onError,
  };
};